import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StaticHtmlDocumentService } from '../../services/static-html-document.service';
import { HtmlDocument } from '../../common/htmlDocument';
import { HtmlDocType } from '../../common/htmlDocType';


@Component({
  selector: 'app-document-list',
  templateUrl: './document-list.component.html',
  styleUrls: ['./document-list.component.scss'],
  standalone: false
})
export class DocumentListComponent implements OnInit {
  documents: HtmlDocument[] = [];
  loading = true;
  error: string | null = null;
  typeLabels: Record<HtmlDocType, string> = { [HtmlDocType.PRIVACY]: 'Datenschutz', [HtmlDocType.AGB]: 'AGB', [HtmlDocType.IMPRESSUM]: 'Impressum' };
  documentTypes: HtmlDocType[] = [HtmlDocType.PRIVACY, HtmlDocType.AGB, HtmlDocType.IMPRESSUM];

  constructor(private router: Router, private route: ActivatedRoute, private documentService: StaticHtmlDocumentService, private cd: ChangeDetectorRef) {}

  ngOnInit(): void { this.loadDocuments(); }

  loadDocuments(): void {
    this.loading = true;
    this.error = null;
    this.documentService.listDocuments().subscribe({
      next: (list) => {
        this.documents = list;
        this.loading = false;
        this.cd.detectChanges();
      },
      error: (err) => {
        this.error = err?.error?.message || 'Fehler beim Laden der Dokumente.';
        this.loading = false;
        this.cd.detectChanges();
      }
    });
  }

  getDocumentByType(type: HtmlDocType): HtmlDocument | undefined {
    return this.documents.find((d) => d.getDocumentType() === type);
  }

  editDocument(documentId: number): void {
    this.router.navigate(['edit', documentId], { relativeTo: this.route.parent });
  }

  createDocument(documentType: HtmlDocType): void {
    this.router.navigate(['new', documentType], { relativeTo: this.route.parent });
  }

  viewVersionHistory(documentId: number): void {
    this.router.navigate(['documents', documentId, 'versions'], { relativeTo: this.route.parent });
  }

  label(type: HtmlDocType): string {
    return this.typeLabels[type] || "not found";
  }
}
